import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { message } from "antd";
import Joi from "joi-browser";
import Form from "../components/Form";
import * as customerService from "../services/customerService";
import auth from "../services/authService";
import { Link, Navigate } from "react-router-dom";
import { showErrorToast } from "V2.0/utils";
import Logo from "./common/Logo";
import password from "./Validators/password";
import PasswordRules from "../components/PasswordRules";

function SignUp() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [inputField, setInputField] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage] = useState({});
  const [passwordValue, setPasswordValue] = useState("");

  const template = [
    {
      name: "firstName",
      label: "First Name *",
      type: "text",
    },
    {
      name: "lastName",
      label: "Last Name *",
      type: "text",
    },
    {
      name: "email",
      label: "Email *",
      type: "email",
      placeholder: "youremail@example.com",
    },
    {
      name: "password",
      label: "Password *",
      type: "password",
      placeholder: "Enter your password",
      info: <PasswordRules value={passwordValue} />,
    },
  ];

  const buttonInfo = {
    label: "Get started ",
    style: "entire-width",
    class:
      "w-full inline-flex items-center justify-center rounded-lg border text-base font-semibold px-4 py-2 text-white bg-zinc-900 focus:outline-none",
  };

  const schema = {
    firstName: Joi.string().max(25).required().label("First Name"),
    lastName: Joi.string().max(25).required().label("Last Name"),
    email: Joi.string().email().required().label("Email"),
    password: password.string().policy().required().label("Password"),
  };

  useEffect(() => {
    setInputField((prevInputField) => {
      return {
        ...prevInputField,
        firstName: searchParams.get("firstName"),
        lastName: searchParams.get("lastName"),
        email: searchParams.get("email"),
      };
    });
  }, [searchParams]);

  const handleSubmit = async (user) => {
    // if (error) {
    //   message.error("Invalid Sign Up, please contact admin");
    //   setLoading(false);
    //   return;
    // }

    const payload = {
      ...user,
    };

    try {
      const response = await customerService.signUpPortal(payload);
      if (response.status === 200) {
        auth.loginWithJwt(response.data.token);
        navigate("/");
      }
    } catch (e) {
      setLoading(false);
      showErrorToast(e, "Failed to create account");
    }
  };

  return auth.getCurrentUser() ? (
    <Navigate to="/" />
  ) : (
    <div className="bg-slate-50  flex items-center justify-center h-screen w-screen ">
      <div className="relative w-[500px] rounded-xl bg-white shadow-[0px_0px_0px_1px_rgba(9,9,11,0.07),0px_2px_2px_0px_rgba(9,9,11,0.05)] dark:bg-zinc-900 dark:shadow-[0px_0px_0px_1px_rgba(255,255,255,0.1)] p-20">
        <div className="space-y-8">
          <Logo />
          <Form
            formTitle={"Sign Up"}
            errorMessage={errorMessage}
            inputField={inputField}
            template={template}
            schema={schema}
            buttonInfo={buttonInfo}
            getValue={(data) => setPasswordValue(data.password || "")}
            onSubmit={handleSubmit}
            loading={loading}
            setLoading={setLoading}
          />
          <p className="text-base text-zinc-500 sm:text-sm dark:text-zinc-400">
            Already have an account?{" "}
            <Link
              to="/login"
              className="font-semibold text-zinc-950 hover:text-zinc-700 dark:text-white dark:hover:text-zinc-300"
            >
              Log In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default SignUp;
